const createImageData = (data, width, height) => new ImageData(new Uint8ClampedArray(data), width, height)

export default createImageData
